import { useTheme } from '@mui/material';
// import { UserIconProps } from './iconProps.interface';

export const WalletIcon = () => {
    const theme = useTheme();
    const primaryIconStrokeColor = theme.colors.other.icon.stroke.primary;

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={58} height={58} fill="none">
            <path
                fill={primaryIconStrokeColor}
                d="M10.875 12.083H9.667v33.834h38.666v-29H16.917v2.416h29V43.5H12.083v-29h33.834v-2.417H10.875ZM38.667 33.23a1.813 1.813 0 1 0 0-3.626 1.813 1.813 0 0 0 0 3.626Z"
            />
        </svg>
    );
};
